import React, {Fragment} from 'react';
import Box from '../layout/Box';
import createEditor from '../form/ComponentEditor';
import WriteOffList from "./lists/WriteOffList";
import WriteOffForm from "./forms/WriteOffForm";
import {postData} from "../../utils/request";
import Modal from "../layout/Modal";
import isEqual from "lodash-es/isEqual";
import BoxEditor from "./BoxEditor";
import ModalEditor from "./ModalEditor";
import shippingEditor from "./shippingEditor";
import Button from "../form/Button";
import StoreOrderEditor, {StoreOrderClaim} from "./storeorder/storeorderEditor";
import StockTransferForm from "./forms/stocktransferForm";
import Confirm from "../form/Confirm";
import SelectorGrid from "../form/SelectorGrid/SelectorGrid";
import {Tooltip} from "react-tippy";
import CheckBox from "../form/CheckBox";
import {CurrencyFormatter, ProductColumn, UnitFormatter} from "../../utils/formatters";
import TextInput from "../form/TextInput";
import {ifCompletedInput, operation} from "../../utils/other";
import debounce from "lodash-es/debounce";

export const stateConst = {
    Initiated: 0,
    Modification: 50,
    UnderRevision: 100,
    MissingStock: 107,
    WaitingForStock: 110,
    StockReserved: 120,
    OriginStoreOrderDelete: 130,
    OriginStoreOrderSent: 200,
    OriginStoreOrderClaim: 210,
    OriginStoreOrderCompleted: 220,
    ShippingOrdered: 300,
    ShippingFailed: 310,
    ShippingCompleted: 320,
    DestinationStoreOrderSent: 400,
    Correctional: 405,
    DestinationStoreOrderClaim: 410,
    TransferCompleted: 520,
    DestinationStoreOrderReversal: 910,
    DestinationStoreOrderReversalSent: 915,
    DestinationStoreOrderReversed: 920,
    ShippingReversal: 930,
    ReverseShippingFailed: 935,
    ReverseShippingCompleted: 940,
    OriginStoreOrderReversalSent: 950,
    OriginStoreOrderReversed: 960,
    Deleted: 990,
};

const stateType = {};
Object.keys(stateConst).forEach((key) => {
    stateType[key] = (state, operator) => operation(state, stateConst[key], operator)
});

class WriteOffEditor extends React.Component {

    stateButtons = (state) => {
        return {
            [stateConst.MissingStock + ""]: "Várakoztatás",
            [stateConst.OriginStoreOrderCompleted + ""]: "Szállítás újra rendelése"
        }[state + ""] || "Mehet";
    };

    stateButtonEnabled = (state) => [
        stateType.Initiated,
        stateType.Modification,
        stateType.UnderRevision,
        stateType.MissingStock,
        stateType.WaitingForStock,
        stateType.StockReserved,
        stateType.OriginStoreOrderClaim,
        stateType.OriginStoreOrderCompleted,
        stateType.ShippingFailed,
        stateType.ShippingCompleted,
        stateType.DestinationStoreOrderSent,
        stateType.Correctional,
        stateType.DestinationStoreOrderClaim,
    ].filter((f) => f(state)).length;

    state = {
        editableFields: [],
        modifiable: false
    };

    constructor(props) {
        super(props);
        this.loadEditableFields();
    }

    loadEditableFields = debounce(() => {
        this.loadEditableFieldsRequest?.abort();
        if (this.props.values[this.props.componentConfig.idfield]) {
            this.loadEditableFieldsRequest = postData({
                action: this.props.componentConfig.componentname + '.getModificationConfig',
                [this.props.componentConfig.idfield]: this.props.values[this.props.componentConfig.idfield],
            });
            this.loadEditableFieldsRequest.then((res) => {
                this.setState({
                    editableFields: res.fields,
                    modifiable: res.modifiable
                });
            });
        } else {
            this.setState({
                editableFields: [],
                modifiable: false
            });
        }
    });

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (
            prevProps.values[prevProps.componentConfig.idfield] + "" !== "" + this.props.values[this.props.componentConfig.idfield]
            ||
            parseInt(this.props.values.modifying || "0") !== parseInt(prevProps.values.modifying || "0")
            ||
            parseInt(this.props.values.state || "0") !== parseInt(prevProps.values.state || "0")
        ) {
            this.setState({
                editableFields: [],
                modifiable: false
            });
            this.loadEditableFields();
        }
    }

    setFieldValue = (field, value) => {
        this.props.setFieldValue(field, value);
    }

    proceedState = async () => {
        const values = this.props.values;
        await this.props.processAction(async () => {
            const response = await postData({
                action: this.props.componentConfig.componentname + '.proceedState',
                data: values
            });
            if (response.success) {
                this.list && this.list.refreshBackground();
                this.form && this.form.refreshBackground();
            }
            return response;
        });
    }

    render() {

        const ShippingEditor = shippingEditor;

        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;

        const actionButtons = [];
        const modifying = parseInt(this.props.values.modifying);
        if (!modifying) {
            if (stateType.MissingStock(this.props.values.state)) {
                actionButtons.push(
                    <Confirm
                        key="8"
                        color="primary"
                        className="pull-right"
                        header="Biztos mehet?"
                        body="Biztos elengeded? A hiányban lévő tételek módosításra kerülnek!"
                        onAccept={async () => {
                            const values = this.props.values;
                            await this.props.processAction(async () => {
                                const response = await postData({
                                    action: this.props.componentConfig.componentname + '.proceedState',
                                    data: values,
                                    modify_stock: true
                                });
                                if (response.success) {
                                    this.list && this.list.refreshBackground();
                                    this.form && this.form.refreshBackground();
                                }
                                return response;
                            });
                        }}
                    >
                        Mehet
                    </Confirm>
                );
            }
            actionButtons.push(
                <Button
                    key="1"
                    disabled={this.props.isLoading || !this.stateButtonEnabled(this.props.values.state)}
                    color="primary"
                    className="pull-right"
                    onClick={this.proceedState}
                >
                    {this.stateButtons(this.props.values.state)}
                </Button>
            );
        }
        if (this.state.modifiable) {
            actionButtons.push(
                <Confirm
                    key="10"
                    disabled={this.props.isLoading}
                    color="warning"
                    header={modifying ? "Biztos kilépsz a módosításból?" : "Biztos módosítod?"}
                    body={modifying ? "Biztos kilépsz a módosításból?" : "Biztos módosítod?"}
                    acceptButton={modifying ? "Véglegesítése" : "Módosítás"}
                    className="pull-right"
                    onAccept={async () => {
                        const values = this.props.values;
                        await this.props.processAction(async () => {
                            const response = await postData({
                                action: this.props.componentConfig.componentname + '.' + (modifying ? 'resume' : 'suspend'),
                                data: values
                            });
                            if (response.success) {
                                this.list?.refreshBackground();
                                this.form?.refreshBackground();
                            }
                            return response;
                        });
                    }}
                >
                    {modifying ? "Véglegesítése" : "Módosítás"}
                </Confirm>
            );
        }
        actionButtons.push(
            <Button
                key="1"
                disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                color="danger"
                onClick={this.props.deleteForm}
            >
                Törlés
            </Button>
        );
        if (stateType.TransferCompleted(this.props.values.state)) {
            actionButtons.push(
                <StoreOrderClaim
                    key="6"
                    {...this.props}
                />
            );
        }

        return (
            <Fragment>
                <List
                    {...this.props}
                    collapsed={this.props.collapsed || false}
                    theme="default"
                    header={"Leírás lista"}
                >
                    <WriteOffList ref={(el) => this.list = el} {...this.props} />
                </List>
                {this.props.values[this.props.componentConfig.idfield] && <Editor
                    {...this.props}
                    theme="default"
                    header={"Leírás adatai"}
                    footer={actionButtons}
                >
                    <WriteOffForm
                        stateConst={stateConst}
                        stateType={stateType}
                        editableFields={this.state.editableFields}
                        ref={(form) => this.form = form}
                        {...this.props}
                    />
                </Editor>}
                {
                    this.props.values[this.props.componentConfig.idfield]
                    &&
                    (this.props.values.origin || {}).id !== (this.props.values.destination || {}).id
                    &&
                    <Fragment>
                        <StoreOrderEditor
                            editorContext="WriteOffStoreOrderEditorOut"
                            gridid="WriteOffStoreOrderListOut"
                            collapsed={!(parseInt(this.props.values.state + "") >= 200 && parseInt(this.props.values.state + "") <= 220)}
                            out={true}
                            client={this.props}
                            listFilter={[
                                {
                                    field: "client_component",
                                    value: this.props.componentConfig.componentname
                                },{
                                    field: "client_component_id",
                                    value: this.props.values[this.props.componentConfig.idfield]
                                }
                            ]}
                            editor={ModalEditor}
                            selection={null}
                            onProcessAction={() => {
                                if (!this.props.isLoading) {
                                    this.props.reloadForm && this.props.reloadForm();
                                }
                            }}
                        />
                        <ShippingEditor
                            editorContext="WriteOffShippingEditor"
                            gridid="WriteOffShippingList"
                            pageSize={0}
                            presets={{
                                client_component: this.props.componentConfig.componentname,
                                client_component_type: this.props.componentConfig.componentname,
                                client_component_id: this.props.values[this.props.componentConfig.idfield],
                            }}
                            collapsed={!(parseInt(this.props.values.state + "") >= 220 && parseInt(this.props.values.state + "") < 400)}
                            editor={ModalEditor}
                            businessComponent={this.props}
                            disable={!(stateType.ShippingFailed(this.props.values.state) || stateType.OriginStoreOrderCompleted(this.props.values.state))}
                            selection={null}
                            saveForm={async () => {
                                this.props.reloadForm && this.props.reloadForm();
                            }}
                            onProcessAction={() => {
                                if (!this.props.isLoading) {
                                    this.props.reloadForm && this.props.reloadForm();
                                }
                            }}
                        />
                    </Fragment>
                }
            </Fragment>
        );
    }
}

export default createEditor({
    editor: "WriteOffs",
    componentName: "WriteOff",
    WrappedComponent: WriteOffEditor,
    props: {
        view: "admin"
    }
});
